import { TimeOption } from '@abg/kit-base';
import {
  Brand,
  HolidaysSchedule,
  OpeningHours,
  TimeFormat,
} from '@abg/typings';

export type InitialDraftStateT = {
  dates: { from: Date | undefined; to?: Date | undefined } | undefined;
  pickupTime: string;
  dropoffTime: string;
};

export type DateTimePickerProperties = {
  isOpen: boolean;
  onClose: () => void;
  onDone: (draftValues: InitialDraftStateT) => void;
  anchorRef: React.RefObject<HTMLDivElement | null>;
  uiTextData: {
    datesTitle: string;
    buttonDoneTitle: string;
    buttonCancelTitle: string;
    timePickerPickupTitle: string;
    timePickerDropoffTitle: string;
    timePickerDropoff24hSubTitle: string;
  };
  timePickerOptions: TimeOption[];
  pickUpOpeningHours: OpeningHours[];
  pickupHolidays: HolidaysSchedule[];
  dropoffOpeningHours: OpeningHours[];
  dropoffHolidays: HolidaysSchedule[];
  dropoff24hrsFlag: boolean;
  dateRangePickerProps: {
    dateRangePickerMinDateValue: number;
    dateRangePickerMaxDateValue: number;
  };
  initialDraftState: InitialDraftStateT;
  maxBookingPeriod: number;
  brand: Brand;
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined;
  locale?: string;
  timeFormat: TimeFormat;
  disabledRange?: number;
  dateType?: 'pickup' | 'dropoff';
};

export interface HandleValueChange {
  (
    field: keyof InitialDraftStateT,
    value: string | InitialDraftStateT['dates'] | undefined,
  ): void;
}

export interface HandleCancel {
  (event_: React.MouseEvent | React.TouchEvent | MouseEvent | TouchEvent): void;
}

export enum DateTimeAccordions {
  dates = 'dates',
  pickupTime = 'pickupTime',
  dropoffTime = 'dropoffTime',
}

export enum DateTimePickerErrorEnum {
  maxBookingPeriod = 'maxBookingPeriod',
  dropoffTimeNotLaterThanPickup = 'dropoffTimeNotLaterThanPickup',
}
